<template>
  <header
    class="header"
    :style="(route.path === '/homePage' && !isScrolled )? { backgroundColor: 'transparent' } : { backgroundColor: '#FFFFFF' }"
  >
    <div class="header-container">
      <div class="header-logo" @click="windowOpen('https://nfstzx.com/')"></div>
      <nav class="header-nav">
        <ul class="nav-list">
          <li
            v-for="(item, index) in navList"
            :key="index"
            :class="navIndex === index ? 'nav-item--active' : ''"
             class="nav-item"
            @click="navIndex = index; saveNavIndex(index); isNavClick = true; router.push(item.path)"
          >
            {{ item.name }}
          </li>
        </ul>
      </nav>
    </div>
  </header>
</template>

<script>
import { ref ,onMounted, onUnmounted ,watch,onBeforeUnmount} from "vue";
import { useRouter } from "vue-router";
import { useRoute } from "vue-router";
import { useStore } from "vuex";

const navItems = [
  { name: "网站首页", path: "/index" },
  { name: "“1+3”体系", path: "/framework" }, 
  { name: "标准服务", path: "/standardService" },
  { name: "检测服务", path: "/testService" },
  { name: "品质评价服务", path: "/QualityEvaluation" },
  { name: "关于我们", path: "/aboutUs" }
];

export default {
  name: "qqst-header",
  setup() {
    const store = useStore();
    const router = useRouter();
    const route = useRoute();
    const navIndex = ref(0);
    const isScrolled = ref(false);
    const handleScroll = () => {
      isScrolled.value = window.scrollY > 0;
    };
    // 根据当前路径找到最匹配的导航项
    const findBestMatchNavIndex = (path) => {
      console.log(path,'findBestMatchNavIndexpath')
      // 首先尝试精确匹配
      let exactMatch = navItems.findIndex(item => item.path === path);
      if (exactMatch !== -1) {
        return exactMatch;
      }
      
      // 如果没有精确匹配，尝试找到包含在路径中的最长匹配项
      let bestMatchIndex = -1;
      let bestMatchLength = 0;
      
      navItems.forEach((item, index) => {
        // 确保路径是以导航项路径开头，避免部分匹配
        if (path.startsWith(item.path) && item.path.length > bestMatchLength) {
          bestMatchIndex = index;
          bestMatchLength = item.path.length;
        }
      });
       console.log(bestMatchIndex,'findBestMatchNavIndexbestMatchIndex')
       const savedIndex = sessionStorage.getItem('currentNavIndex');
      return bestMatchIndex !== -1 ? bestMatchIndex : savedIndex?parseInt(savedIndex):0;
    };
    
    // 保存当前导航索引到sessionStorage
    const saveNavIndex = (index) => {
      sessionStorage.setItem('currentNavIndex', index.toString());
    };
    
    // 标记是否是通过点击导航项导致的路由变化
    const isNavClick = ref(false);
    
    watch(()=>route.path,(newPath)=>{
      console.log(newPath,'watchpath')
      // 如果是通过点击导航项导致的路由变化，不重新计算导航索引
      if (isNavClick.value) {
         isNavClick.value = false; // 重置标记
        return;
      }
      
      // 否则，根据路径计算最佳匹配的导航索引
      const bestMatchIndex = findBestMatchNavIndex(newPath);
      navIndex.value = bestMatchIndex;
       console.log('watchnavIndex',navIndex.value);
      // if(){
        saveNavIndex(bestMatchIndex);
      // }
    },{immediate:true});
    // 打开新窗口
    const windowOpen = (url) => {
      window.open(url, '_blank');
    };
    onBeforeUnmount(() => {
      // 清除缓存
      sessionStorage.setItem('currentNavIndex',0)
    });
    onMounted(() => {
       window.addEventListener('popstate', function(event) {
    // 可以在这里处理阻止回退的逻辑
    
    // 重新设置状态，阻止后退
    
      history.go(0); // 向前移动一个页面，相当于阻止了后退
    });
      window.addEventListener("scroll", handleScroll);
      
      // 尝试从sessionStorage恢复导航索引
      const savedIndex = sessionStorage.getItem('currentNavIndex');
      if (savedIndex !== null) {
        navIndex.value = parseInt(savedIndex);
      } else {
        // 如果没有保存的索引，根据当前路径计算
        const bestMatchIndex = findBestMatchNavIndex(route.path);
        navIndex.value = bestMatchIndex;
        saveNavIndex(bestMatchIndex);
      }
    });
    onUnmounted(() => {
      window.removeEventListener("scroll", handleScroll);
    });
    return {
      navIndex,
      navList: navItems,
      router,
      route,
      isScrolled,
      saveNavIndex,
      windowOpen
    };
  }
};
</script>

<style lang="less">
.header {
  width: 100%;
  height: 72px;
  position: fixed;
  z-index: 1000;
  transition: background-color 0.5s;
  // background: #FFFFFF;
  
  &-container {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  &-logo {
    width: 453px;
    height: 46px;
    background-image: url('@/assets/images/homePage/logo.png');
    background-size: cover;
    cursor: pointer;
  }
  &-nav {
    .nav-list {
      display: flex;
      list-style: none;
      margin: 0;
      padding: 0;
      
      .nav-item {
        padding: 0 20px;
        cursor: pointer;
        color: #333333;
        font-size: 16px;
        line-height: 72px;
        transition: color 0.3s;
        
        &:hover,
        &--active {
          color: #0754BD;
        }
      }
    }
  }
}
</style>